import React, { useMemo } from 'react';
import { AlarmClockIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
import { getOfferDeadline, spotsTakenPercent } from '../utils/offer';
function pad(value: number): string {
  return value.toString().padStart(2, '0');
}

/** Bloque de urgencia que se sitúa justo encima de la tarjeta de precio. */
export function CountdownTimer() {
  const deadline = useMemo(() => getOfferDeadline(), []);
  const {
    hours,
    minutes,
    seconds,
    isExpired
  } = useCountdown(deadline);
  const units = [{
    value: hours,
    label: 'horas'
  }, {
    value: minutes,
    label: 'min'
  }, {
    value: seconds,
    label: 'seg'
  }];
  return <div className="rounded-3xl border border-track/40 bg-track/10 px-5 py-6 text-center sm:px-7" data-id="element-26" data-mp="15dw96fp7bif3">
      <p className="flex items-center justify-center gap-2 font-sans text-[11px] font-semibold uppercase tracking-[0.18em] text-track-light" data-id="element-27" data-mp="34qi72wo9oj21">
        <AlarmClockIcon className="h-4 w-4" strokeWidth={2} aria-hidden="true" data-id="element-28" data-mp="2zs6y0o5sqckv" />
        Precio de lanzamiento — termina en:
      </p>

      {isExpired ? <p className="mt-4 font-display text-xl font-bold leading-snug text-ivory" data-id="element-29" data-mp="1gzi2w9h7tcqw">
          El precio de lanzamiento ha terminado.
        </p> : <>
          <div className="mx-auto mt-5 grid max-w-sm grid-cols-3 gap-2 sm:gap-3" aria-hidden="true" data-id="element-30" data-mp="12423rq1s2qnn">
            {units.map(unit => <div key={unit.label} className="flex flex-col items-center justify-center rounded-2xl border border-line bg-ink px-2 py-3 text-center" data-id="element-31" data-mp="173oik3x98eyk">
                <span className="block font-display text-3xl font-bold leading-none text-ivory sm:text-4xl" data-id="element-32" data-mp="1zqj2mzq5tcbi">
                  {pad(unit.value)}
                </span>
                <span className="mt-1.5 block font-sans text-[10px] font-semibold uppercase tracking-[0.12em] text-stone" data-id="element-33" data-mp="1q0g82v3e3qb2">
                  {unit.label}
                </span>
              </div>)}
          </div>
          <p className="sr-only" role="timer" data-id="element-34" data-mp="2igh9xdm4v1e3">
            Quedan {hours} horas, {minutes} minutos y {seconds} segundos al
            precio de lanzamiento.
          </p>

          <div className="mt-6 border-t border-line pt-5" data-id="element-35" data-mp="2sadcvev2lcjh">
            <div className="flex items-baseline justify-between gap-4 font-sans text-[10px] font-semibold uppercase tracking-[0.14em] text-stone" data-id="element-36" data-mp="2nexymlt5hemj">
              <span data-id="element-37" data-mp="2ecyj5xxsailp">Cupos de lanzamiento</span>
              <span className="text-track-light" data-id="element-38" data-mp="2ec6kufcsy6rq">Quedan pocos</span>
            </div>
            <div className="mt-3 h-2 w-full overflow-hidden rounded-full bg-graphite" role="progressbar" aria-valuenow={spotsTakenPercent} aria-valuemin={0} aria-valuemax={100} aria-label="Cupos de lanzamiento tomados" data-id="element-39" data-mp="29e50zs7jy3f7">
              <div className="h-full rounded-full bg-track" style={{
            width: `${spotsTakenPercent}%`
          }} data-id="element-40" data-mp="1zov84a4vwgq1" />
            </div>
            <p className="mt-2 text-right font-sans text-[11px] text-stone" data-id="element-41" data-mp="1qndwb3yif175">
              {spotsTakenPercent}% de cupos tomados
            </p>
          </div>
        </>}
    </div>;
}